import {
  CognitoUserPool,
  CognitoUser,
  CognitoUserAttribute,
  AuthenticationDetails
} from "amazon-cognito-identity-js";
import axios from "axios";
import { ServerConfig } from "../../connectors/Config";

export class AuthHelper {
  static userPool = new CognitoUserPool(ServerConfig.AWS.Cognito);
  static instance = null;

  // === SINGLETON ===
  static getInstance() {
    if (!this.instance) this.instance = new AuthHelper();
    return this.instance;
  }

  // === SIGNUP ===
  static async signUp(email, password, attributes = {}) {
    const attrList = Object.entries(attributes).map(
      ([Name, Value]) => new CognitoUserAttribute({ Name, Value })
    );

    return new Promise((resolve, reject) => {
      this.userPool.signUp(email, password, attrList, null, (err, res) => {
        if (err) reject(err);
        else resolve(res);
      });
    });
  }

  // === LOGIN ===
  static async login({ Username, Password }) {
    const authDetails = new AuthenticationDetails({ Username, Password });
    const cognitoUser = new CognitoUser({ Username, Pool: this.userPool });

    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authDetails, {
        onSuccess: (result) => {
          localStorage.setItem("cruddy-apiKey", result.getAccessToken().getJwtToken());
          localStorage.setItem("cruddy-user", JSON.stringify(result));
          resolve(result);
        },
        onFailure: reject,
        newPasswordRequired: () => resolve({ status: "new_password_required" })
      });
    });
  }

    // === LOGOUT ===
  static async logout(redirectUrl = "/") {
    localStorage.clear();
    window.location.href = redirectUrl;
  }

 


  // === FORGOT PASSWORD ===
  static forgotPassword(email) {
    const user = new CognitoUser({ Username: email, Pool: this.userPool });

    return new Promise((resolve, reject) => {
      user.forgotPassword({
        onSuccess: resolve,
        onFailure: reject,
        inputVerificationCode: () => resolve(user)
      });
    });
  }

  // === CONFIRM NEW PASSWORD ===
  static confirmPassword(email, code, newPassword) {
    const user = new CognitoUser({ Username: email, Pool: this.userPool });

    return new Promise((resolve, reject) => {
      user.confirmPassword(code, newPassword, {
        onSuccess: () => resolve(true),
        onFailure: () => reject("Codice errato")
      });
    });
  }


   // === GET USER FROM TOKEN ===
  static async getUserFromIdToken() {
    try {
      const token = localStorage.getItem("cruddy-apiKey");
      if (!token) return null;

      const url = `https://cognito-idp.${ServerConfig.AWS.Cognito.Region}.amazonaws.com/`;
      const res = await axios.post(
        url,
        { AccessToken: token },
        {
          headers: {
            "X-Amz-Target": "AWSCognitoIdentityProviderService.GetUser",
            "Content-Type": "application/x-amz-json-1.1"
          }
        }
      );
      return res.data;
    } catch (err) {
      if (err.response?.status === 400) localStorage.clear();
      return null;
    }
  }

  getRoles = async () => {
        let user = await AuthHelper.getUserFromIdToken();
        return user.UserAttributes.filter(x => x.Name === 'custom:roles').Value;
    }

}


